import React, { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import Icon from '../../components/Icon';
import StatsTab from './StatsTab';
import ManageEmployeesTab from './ManageEmployeesTab';
import ManageQuestionsTab from './ManageQuestionsTab';
import ReviewTab from './ReviewTab';
import ReviewModal from '../../components/ReviewModal';

const AdminDashboard = ({ setNotification }) => {
  const [activeTab, setActiveTab] = useState('stats');
  const [employees, setEmployees] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewingQuestion, setReviewingQuestion] = useState(null);

  useEffect(() => {
    const unsubEmployees = onSnapshot(collection(db, "employees"), (snapshot) => {
      setEmployees(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    const unsubQuestions = onSnapshot(collection(db, "questions"), (snapshot) => {
      setQuestions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => {
      unsubEmployees();
      unsubQuestions();
    };
  }, []);
  
  const openReviewModal = (question) => {
    setReviewingQuestion(question);
    setIsReviewModalOpen(true);
  };
  
  const tabs = [
    { id: 'stats', label: 'Dashboard', icon: 'LayoutDashboard' },
    { id: 'review', label: 'Review', icon: 'Eye', count: questions.filter(q => q.status === 'in-review').length },
    { id: 'employees', label: 'Employees', icon: 'Users' },
    { id: 'questions', label: 'Questions', icon: 'FileQuestion' },
  ];

  return (
    <div>
        <ReviewModal 
            isOpen={isReviewModalOpen}
            onClose={() => setIsReviewModalOpen(false)}
            question={reviewingQuestion}
            setNotification={setNotification}
        />
        <div className="flex flex-col md:flex-row gap-8">
          <aside className="w-full md:w-1/4">
            <nav className="space-y-2">
              {tabs.map(tab => (
                <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`w-full flex items-center justify-between gap-3 px-4 py-2 rounded-md text-left transition-colors ${activeTab === tab.id ? 'bg-indigo-600 text-white' : 'text-slate-600 hover:bg-slate-100'}`}>
                  <div className="flex items-center gap-3">
                    <Icon name={tab.icon} className="w-5 h-5" />
                    <span className="font-semibold">{tab.label}</span>
                  </div>
                  {tab.count > 0 && <span className="bg-amber-400 text-amber-900 text-xs font-bold px-2 py-0.5 rounded-full">{tab.count}</span>}
                </button>
              ))}
            </nav>
          </aside>
          <main className="w-full md:w-3/4">
            {activeTab === 'stats' && <StatsTab employees={employees} questions={questions} />}
            {activeTab === 'review' && <ReviewTab questions={questions} employees={employees} onSelectQuestion={openReviewModal} />}
            {activeTab === 'employees' && <ManageEmployeesTab employees={employees} setNotification={setNotification} />}
            {activeTab === 'questions' && <ManageQuestionsTab questions={questions} employees={employees} setNotification={setNotification} />}
          </main>
        </div>
    </div>
  );
};

export default AdminDashboard;

